import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../api/client';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') ?? '';
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    if (newPassword !== confirm) { setError('Passwords do not match'); return; }
    if (newPassword.length < 6) { setError('Password must be at least 6 characters'); return; }
    try {
      await api.post('/auth/reset-password', { token, newPassword });
      setDone(true);
    } catch (err: any) {
      setError(err.response?.data?.detail ?? 'Invalid or expired reset link');
    }
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Auction Platform</h1>
        <h3 style={styles.subtitle}>Set New Password</h3>
        {done ? (
          <>
            <p style={styles.success}>Password updated successfully.</p>
            <button style={styles.button} onClick={() => navigate('/')}>Back to Login</button>
          </>
        ) : (
          <form onSubmit={handleSubmit} style={styles.form}>
            <input style={styles.input} type="password" placeholder="New password"
              value={newPassword} onChange={e => setNewPassword(e.target.value)} required />
            <input style={styles.input} type="password" placeholder="Confirm new password"
              value={confirm} onChange={e => setConfirm(e.target.value)} required />
            {error && <p style={styles.error}>{error}</p>}
            <button style={styles.button} type="submit">Update Password</button>
          </form>
        )}
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f0f2f5' },
  card: { background: 'white', padding: '2rem', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', width: '360px' },
  title: { textAlign: 'center', marginBottom: '0.5rem', color: '#1a1a2e' },
  subtitle: { textAlign: 'center', margin: '0 0 1.5rem', color: '#555', fontWeight: 500 },
  form: { display: 'flex', flexDirection: 'column', gap: '0.75rem' },
  input: { padding: '0.6rem', border: '1px solid #ddd', borderRadius: '4px', fontSize: '1rem' },
  button: { padding: '0.75rem', background: '#4a90e2', color: 'white', border: 'none', borderRadius: '4px', fontSize: '1rem', cursor: 'pointer' },
  error: { color: 'red', fontSize: '0.875rem', margin: 0 },
  success: { color: '#2e7d32', fontSize: '0.875rem', marginBottom: '1rem' },
};
